import { useState } from "react";

import { useAuthorization } from "../../common/AuthorizationCpt";
import { ACE_BLOCK_MESSAGES, DAM_STATUS } from "../../utils/constants";
import CommentModal from "../CommentModal/CommentModal";
import FileUploadMandateModal from "../FileUploadMandateModal/FileUploadMandateModal";
import FileUploadSenasaModal from "../FileUploadSenasaModal/FileUploadSenasaModal";
import SidebarSenasaElectronic from "../Sidebar/SidebarSenasaElectronic";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import {
  Container,
  DamInfo,
  StatusCard,
  StatusDiv,
  StatusInfo,
} from "./DamStatusSidebarStyles";

function StatusSidebar(props) {
  const { dam, senasaHook, electronicMandateHook, status, refreshBilling } =
    props;
  const [showSenasaModal, updateShowSenasaModal] = useState(false);
  const [showMandateModal, updateShowMandateModal] = useState(false);
  const [, updateSenasaStatus] = senasaHook;
  const { problems } = status;
  const numberProblems = problems.length;

  const [, updateElectronicMandateStatus] = electronicMandateHook;
  const [showCommentModal, updateShowCommentModal] = useState(false);
  const [statusType, updateStatusType] = useState(-1);
  const [damComment, updateDamComment] = useState("");

  const dictionary = {
    electronic_mandate_status: "MANDATO ELECTRÓNICO",
    senasa_status: "RESTRICCIÓN SENASA",
    ace_block_status: "BLOQUEO ACE",
    levante_status: "RESTRICCIÓN DE LEVANTE",
    endorsement_status: "endorsement_status",
    handling_payment_status: "handling_payment_status",
  };

  const statusCardOnClick = (statusId, option) => {
    option = "pending";
    const validOptions = ["pending", "rejected"];
    switch (statusId) {
      case "senasa_status":
        if (
          dam.senasa_status.option === "rejected" ||
          dam.senasa_status.option === "pending"
        ) {
          if (validOptions.indexOf(option) !== -1) {
            updateStatusType(DAM_STATUS.SENASA.id);
            updateDamComment(dam.senasaComment);
            if (option === "rejected") updateShowCommentModal(true);
            else updateShowSenasaModal(true);
          }
        }
        break;
      case "electronic_mandate_status":
        if (
          dam.electronic_mandate_status.option === "rejected" ||
          dam.electronic_mandate_status.option === "pending"
        ) {
          if (validOptions.indexOf(option) !== -1) {
            updateStatusType(DAM_STATUS.ELECTRONIC_MANDATE.id);
            updateDamComment(dam.electronicMandateComment);
            if (option === "rejected") updateShowCommentModal(true);
            else updateShowMandateModal(true);
          }
        }
        break;
      default:
        break;
    }
  };

  const toggleCommentModal = () => {
    updateShowCommentModal(!showCommentModal);
  };
  const [showSidebar, updateShowSidebar] = useState(false);

  const toggleStatusSidebar = () => {
    updateShowSidebar(!showSidebar);
  };
  const authorization = useAuthorization();

  const [hasSenasaPermission] = useState(() => {
    return authorization.isAllowedByActions("dam.update_dam_senasa_agent");
  });

  const [hasElectronicPermission] = useState(() => {
    return authorization.isAllowedByActions(
      "dam.update_dam_electronic_mandate_agent"
    );
  });

  const dictionaryPermissions = {
    senasa_status: hasSenasaPermission,
    electronic_mandate_status: hasElectronicPermission,
  };
  const statusSenasaElectronic =
    dam.senasa_status.option === "rejected" ||
    dam.senasa_status.option === "pending" ||
    dam.electronic_mandate_status.option === "rejected" ||
    dam.electronic_mandate_status.option === "pending";

  return (
    <StatusDiv
      status={numberProblems === 0 ? "ok" : "problem"}
      onClick={toggleStatusSidebar}
      clickable={true}
      style={{ cursor: "pointer" }}
    >
      <span>{`${numberProblems === 0 ? "SIN" : numberProblems} RESTRICCI${
        numberProblems === 1 ? "ÓN" : "ONES"
      }`}</span>
      {showSidebar && (
        <SidebarSenasaElectronic onOutsideClick={toggleStatusSidebar}>
          <Container>
            <DamInfo className="header">
              <p className="dam-id">{`${dam.id}`}</p>
              <p className="consignee-name">{dam.consigneeName}</p>
              <StatusDiv status={numberProblems > 0 ? "problem" : "ok"}>
                <span>{`${
                  numberProblems === 0 ? "SIN" : numberProblems
                } RESTRICCI${numberProblems === 1 ? "ÓN" : "ONES"}`}</span>
              </StatusDiv>
            </DamInfo>
            <StatusInfo className="content">
              {numberProblems === 0 && (
                <StandaloneMessage>
                  Esta DAM no tiene ninguna restricción.
                </StandaloneMessage>
              )}
              {numberProblems > 0 &&
                problems.map((problem, index) => {
                  const hasPermission = !!dictionaryPermissions[problem.key];
                  return (
                    <StatusCard
                      key={index}
                      style={{
                        cursor: statusSenasaElectronic
                          ? "pointer"
                          : "not-allowed",
                      }}
                      onClick={() =>
                        hasPermission &&
                        statusCardOnClick(problem.key, status.option)
                      }
                    >
                      <div className="status-section">
                        <StatusDiv status={problem.category}>
                          <span>{dictionary[problem.key].toUpperCase()}</span>
                        </StatusDiv>
                        <StatusDiv status={problem.category}>
                          <span>{problem.label.toUpperCase()}</span>
                        </StatusDiv>
                      </div>
                      {problem.key === "ace_block_status" ? (
                        ACE_BLOCK_MESSAGES[problem.code].map(
                          (message, index) => {
                            return <p key={index}>{message}</p>;
                          }
                        )
                      ) : (
                        <p>{problem.message}</p>
                      )}
                    </StatusCard>
                  );
                })}
            </StatusInfo>
          </Container>
          {showCommentModal && (
            <CommentModal
              toggleModal={toggleCommentModal}
              title="Documento rechazado"
              message={damComment}
              onAccept={() => {
                statusType === DAM_STATUS.SENASA.id
                  ? updateShowSenasaModal(true)
                  : updateShowMandateModal(true);
                toggleCommentModal();
              }}
            />
          )}
          {showSenasaModal && (
            <FileUploadSenasaModal
              damNum={dam.id}
              hideModal={() => updateShowSenasaModal(false)}
              updateSenasaStatus={updateSenasaStatus}
              refreshBilling={refreshBilling}
            />
          )}
          {showMandateModal && (
            <FileUploadMandateModal
              damNum={dam.id}
              hideModal={() => updateShowMandateModal(false)}
              updateElectronicMandateStatus={updateElectronicMandateStatus}
              refreshBilling={refreshBilling}
            />
          )}
        </SidebarSenasaElectronic>
      )}
    </StatusDiv>
  );
}

export default StatusSidebar;
